import { n as o } from "./property-9daa16cd.mjs";
import { e as v } from "./class-map-2994e95e.mjs";
import { i as d, b as m, E as u, x as p, a as g, r as y } from "./createReactComponent-58f9bea8.mjs";
import { P as b, a as c, r as $ } from "./pill-a1831740.mjs";
import { r as x } from "./button-7600b6ca.mjs";
import { g as f } from "./utils-cf5bbdd1.mjs";
var w = Object.defineProperty, P = Object.getOwnPropertyDescriptor, s = (a, t, i, e) => {
  for (var n, r = e > 1 ? void 0 : e ? P(t, i) : t, h = a.length - 1; h >= 0; h--)
    (n = a[h]) && (r = (e ? n(t, i, r) : n(r)) || r);
  return e && r && w(t, i, r), r;
};
class l extends u {
  constructor() {
    super(...arguments), this.values = [], this.showAllPills = !1, this.showClear = !1, this.color = b.GRAY, this.size = c.REGULAR, this.icon = "", this.removable = !1, this.interactive = !1, this.selected = !1, this.clearEvent = new CustomEvent("onClear", { bubbles: !0, composed: !0, cancelable: !1 });
  }
  handleRemove(t, i) {
    this.dispatchEvent(new CustomEvent("onRemove", { detail: { value: t, index: i }, bubbles: !0, composed: !0, cancelable: !1 }));
  }
  handleClear() {
    this.dispatchEvent(this.clearEvent);
  }
  toggleShowAllPills() {
    this.showAllPills = !this.showAllPills;
  }
  getClearButton() {
    return p`<ex-button
      id="clear-all-button"
      flavor="base"
      type="tertiary"
      size="small"
      @click=${(t) => {
      t.stopPropagation(), this.handleClear();
    }}
      @keydown=${(t) => {
      t.key === "Enter" && (this.handleClear(), t.stopPropagation());
    }}
      data-exo-locatorId-suffix=${f(this, "pill-group-clear-button")}
    >
      Clear all
    </ex-button>`;
  }
  render() {
    const t = this.showAllPills ? this.values : this.values.slice(0, 3), i = this.values.length - 3;
    return p`<div
      class=${v({ "pill-group": !0, "no-pills": this.values.length === 0 })}
    >
      ${t.filter((e) => !!e.label).map((e, n) => p`<ex-pill
            ?interactive=${e.interactive || this.interactive}
            icon="${e.icon || this.icon}"
            color="${e.color || this.color}"
            size=${c.SMALL}
            ?selected=${e.selected || this.selected}
            ?removable=${e.removable || this.removable}
            @onRemove=${() => this.handleRemove(e, n)}
            >${e.label}</ex-pill
          >`)}
      ${!this.showAllPills && i > 0 ? p`<ex-pill
            ?interactive=${this.interactive}
            icon=""
            color=${this.color}
            size=${c.SMALL}
            @click=${() => this.toggleShowAllPills()}
            >+${i}</ex-pill
          >` : ""}
      ${this.showClear && this.values.length > 0 ? this.getClearButton() : g}
    </div>`;
  }
}
l.styles = d`
    ${m(`:host .pill-group{display:flex;flex-wrap:wrap;align-items:center;gap:var(--exo-spacing-x-small);padding:var(--exo-spacing-x-small)}:host .pill-group.no-pills{padding:var(--exo-spacing-none)}
`)}
  `, s([o({ type: Array })], l.prototype, "values", 2), s([o({ type: Boolean })], l.prototype, "showAllPills", 2), s([o({ type: Boolean, reflect: !0 })], l.prototype, "showClear", 2), s([o({ reflect: !0 })], l.prototype, "color", 2), s([o({ reflect: !0 })], l.prototype, "size", 2), s([o()], l.prototype, "icon", 2), s([o({ type: Boolean })], l.prototype, "removable", 2), s([o({ type: Boolean })], l.prototype, "interactive", 2), s([o({ type: Boolean })], l.prototype, "selected", 2);
const L = (a = "") => {
  y("ex-pill-group", l, a), $(a), x(a);
};
export {
  l as P,
  L as r
};
